// src/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Anonysis. All rights reserved.</p>
      <p>
        <Link to="/privacy">Privacy Policy</Link>
        {" "} | {" "}
        <Link to="/terms">Terms of Service</Link>
        {" "} | {" "}
        Contact: <a href="mailto:info@anonysis.io">info@anonysis.io</a>
      </p>
    </footer>
  );
}

export default Footer;
